// extracted by mini-css-extract-plugin
export default {"statusWrapper":"VerificationStatus_statusWrapper__SZROv","error":"VerificationStatus_error__D4cjQ"};